import {AgencyRepository} from "../../../repositories/AgencyRepository.ts";
import {AgencyUser, CreateAgencyUserPhoneRequest} from "../../entities/AgencyUser.ts";

export class CreateAgencyUserWithPhoneUseCase {
    constructor(private readonly agencyRepository: AgencyRepository) {}

    async execute(agencyId: string, data: CreateAgencyUserPhoneRequest): Promise<AgencyUser> {
        return this.agencyRepository.createAgencyUserWithPhone(agencyId, data)
    }
}
